import { memo } from 'react'

import LeapFrogPage, { TEST_ID } from './LeapFrog'

const LeapFrog = memo(LeapFrogPage)

export { TEST_ID }

export default LeapFrog
